import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withKeys as _withKeys, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = { class: "flex flex-column pt-3 gap-3 sm:flex-row sm:justify-content-between sm:align-items-center sm:pb-5 sm:hidden" }
const _hoisted_3 = { class: "text-2xl" }
const _hoisted_4 = {
  key: 0,
  class: "flex gap-6 pt-5"
}
const _hoisted_5 = { class: "flex flex-column line-height-1 w-full sm:w-9" }
const _hoisted_6 = { class: "m-0 overflow-clip text-overflow-ellipsis" }
const _hoisted_7 = { class: "flex align-items-center mb-3 mt-2 flex-wrap" }
const _hoisted_8 = { class: "flex gap-2 align-items-center w-full py-3 sm:w-fit sm:py-0" }
const _hoisted_9 = {
  key: 0,
  class: "text-sm px-2 py-1 surface-200 border-round-3xl"
}
const _hoisted_10 = { class: "text-sm" }
const _hoisted_11 = { class: "flex align-items-center gap-2 text-sm" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user" }, null, -1)
const _hoisted_13 = ["src", "alt"]
const _hoisted_14 = {
  key: 1,
  class: "relative flex justify-content-center align-items-center"
}
const _hoisted_15 = { class: "mb-0 font-bold line-height-2 overflow-hidden text-overflow-ellipsis" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = ["href"]
const _hoisted_18 = { key: 3 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2 w-full border-bottom-1 border-400" }, null, -1)
const _hoisted_20 = { class: "flex align-items-center gap-3 mt-4" }
const _hoisted_21 = { class: "hidden sm:flex flex-column gap-4 w-3" }
const _hoisted_22 = { class: "text-500 font-bold" }
const _hoisted_23 = { class: "fillDialogTitle" }
const _hoisted_24 = { class: "fillDialogButtons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_PlaceholderImage = _resolveComponent("PlaceholderImage")!
  const _component_NewsCard = _resolveComponent("NewsCard")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("news.title")), 1),
        _createVNode(_component_Dropdown, {
          tabindex: "1",
          options: _ctx.filters.filter((f) => !f.divider),
          placeholder: _ctx.$t('news.choose_category'),
          optionLabel: "name",
          class: "flex sm:hidden",
          onChange: _cache[0] || (_cache[0] = (e) => _ctx.goToNews(e.value))
        }, null, 8, ["options", "placeholder"])
      ]),
      (_ctx.article)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.article.title), 1),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  (
                _ctx.article.category &&
                _ctx.$te(`news.categories.${_ctx.article.category.name}`)
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t(`news.categories.${_ctx.article.category.name}`).toUpperCase()), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.article.datetime !== null
                ? _ctx.$moment(_ctx.article.datetime).format("DD. MM. yyyy")
                : _ctx.$moment(_ctx.article.created_at).format("DD. MM. yyyy")), 1),
                  _createElementVNode("span", _hoisted_11, [
                    _hoisted_12,
                    _createTextVNode(_toDisplayString(_ctx.article.author), 1)
                  ])
                ]),
                (_ctx.user)
                  ? _withDirectives((_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "p-3 border-circle border-1 border-200 shadow-1 h-3rem w-3rem cursor-pointer sm:ml-auto",
                      tabindex: "1",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.article.saved ? (_ctx.showDialog = true) : _ctx.saveArticle())),
                      onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.article.saved ? (_ctx.showDialog = true) : _ctx.saveArticle()), ["enter"]))
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass({
                'pi pi-bookmark-fill': _ctx.article.saved,
                'pi pi-bookmark': !_ctx.article.saved,
              })
                      }, null, 2)
                    ], 32)), [
                      [
                        _directive_tooltip,
                        
              _ctx.article.saved ? _ctx.$t('news.remove_saved') : _ctx.$t('news.save_news')
            ,
                        void 0,
                        { top: true }
                      ]
                    ])
                  : _createCommentVNode("", true)
              ]),
              (_ctx.article.image_url !== null)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.article.image_url,
                    alt: _ctx.article.image_alt
                  }, null, 8, _hoisted_13))
                : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createVNode(_component_PlaceholderImage, {
                      view_type: "news",
                      category_key: _ctx.article?.category?.name
                    }, null, 8, ["category_key"])
                  ])),
              _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.article.summary), 1),
              _createElementVNode("div", {
                class: "line-height-2 overflow-hidden text-overflow-ellipsis",
                ref: "htmlContainer",
                innerHTML: _ctx.article.body
              }, null, 8, _hoisted_16),
              (_ctx.article.url)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 2,
                    href: _ctx.article.url,
                    target: "_blank",
                    class: "w-fit my-4",
                    tabindex: "1"
                  }, _toDisplayString(_ctx.$t("news.read_more")), 9, _hoisted_17))
                : _createCommentVNode("", true),
              (_ctx.article.provider)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("span", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t("news.provider")) + ": ", 1),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.article.provider.title), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.article.category_id ? _ctx.$t("news.latest_category") : _ctx.$t("news.latest")), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.latestNews, (item) => {
                return (_openBlock(), _createBlock(_component_NewsCard, {
                  key: item.id,
                  article: item,
                  onSave: ($event: any) => (_ctx.updateSavedValue(item, true)),
                  onUnsave: ($event: any) => (_ctx.updateSavedValue(item, false)),
                  class: "w-18rem"
                }, null, 8, ["article", "onSave", "onUnsave"]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.showDialog,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showDialog) = $event)),
      class: "successDialog",
      tabindex: "1",
      closable: false,
      modal: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t("news.sure")), 1),
        _createElementVNode("div", null, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("news.unsave", { category: _ctx.article?.category })), 1)
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("button", {
            class: "defaultButton",
            tabindex: "1",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.removeSavedArticle && _ctx.removeSavedArticle(...args)))
          }, _toDisplayString(_ctx.$t("news.confirm_unsave")), 1),
          _createElementVNode("span", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showDialog = false)),
            tabindex: "1",
            onKeypress: _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.showDialog = false), ["enter"]))
          }, _toDisplayString(_ctx.$t("global.cancel")), 33)
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}